import { getFromSessionStorage } from "./getFromSessionStorage";
import { conditionalCall } from "./conditionalCall";
import {
  fetchConfigAndRedirect,
  validateAndFetchConfigAndRedirect,
  validateAndCheckException
} from "./fetchConfigRedirect";
import { setGlobalData } from "./setGlobalData";
import { updateVisibility } from "./showHideWidgets";
import { updateMultipleWidgetProps, updatePropsAction } from "./updateProps";
import { setInSessionStorage } from "./setInSessionStorage";
import { handleApplyDiscount } from "./handleApplyDiscount";
import { setPayload } from "./setPayloadData";
import { setInstrumentation } from "./setInstrumentationData";
import { checkValueAndCall } from "./checkValueAndCall";
import { handleAddonUpdate } from "./handleAddonUpdate";
import { scrollIntoViewWrapper } from "./scrollIntoViewWrapper";
import { validateDataAndFields } from "./fieldValidation";
import { VerifyOtpAndRedirect } from "./verifyAndNextNode";
import { handleRouterBack } from "./handleRouterBack";
import { setRequestPayloadData } from "./setRequestPayload";
import { analyticEvents } from "./analyticEvents";
import { checkGlobalDataAndCall } from "./checkGlobalDataAndCall";
import { dispatchCallEvents } from "./dispatchCallAnalytics";
import { GoToHomePage } from "./goToHomePage";
import { checkMutipleValuesAndCall } from "./checkMutipleValuesAndCall";
import CheckoutComponent from "./checkoutApiCall";
import { resetPayloadData } from "./resetPayloadData";
import { resetInstrumentationData } from "./resetInstrumentationData";
import { triggerFirebaseEvent } from "./triggerFirebaseEvent";
import { handleReviewAddonUpdate } from "./handleReviewAddonUpdate";
import { GoToMyAccount } from "./goToMyAccount";
import { RedirectToDefaultPaymentOrAutopay } from "./redirectToDefaultPaymentOrAutopay";
import { RedirectToUrl } from "./redirectToUrl";
import { checkPayload } from "./checkPayload";
import { DownloadAndOpenPdf } from "./downloadAndOpenPdf";
import { redirectionToCheckoutOrNextNode } from "./redirectionToCheckoutOrNextNode";
import { persistPayloadToStorage } from "./persistPayloadToStorage";
import { updateDashcamAddress } from "./updateDashcamAddress";
import { showLoaderAndRedirectToHomepage } from "./showLoaderAndRedirectToHomepage";
import { checkoutAndRedirectToPayment } from "./checkoutAndRedirectToPayment";
import { openHomepage } from "./openHomepage";
import { removePayloadKeyAction } from "./removePayloadKey";
import { ConditionalGoBack } from "./ConditionalGoBack";
import { traiConcentCall } from "./traiConcentCall";
import { updateProposal } from "./updateProposal";
import { appWebViewAuthFlow } from "./appWebViewAuthFlow";
import { fetchOwnershipTransferAndRedirect } from "./fetchOwnershipTransferAndRedirect";
import { dispatchAckoDriveCallback } from "./dispatchAckodriveCallback";
import { openDeeplink } from "./openDeeplink";
import { markDashcamAsDelivered } from "./confirmDashcamDelivery";

const actions = {
  submit_call: updateVisibility,
  fetch_config_redirect: fetchConfigAndRedirect,
  validateAndFetchConfigAndRedirect: validateAndFetchConfigAndRedirect,
  validateAndCheckException: validateAndCheckException,
  setGlobalData: setGlobalData,
  setPayloadData: setPayload,
  setInstrumentationData: setInstrumentation,
  updateProps: updatePropsAction,
  conditionalCall: conditionalCall,
  getFromSessionStorage: getFromSessionStorage,
  setInSessionStorage: setInSessionStorage,
  handleApplyDiscount: handleApplyDiscount,
  handleAddonUpdate: handleAddonUpdate,
  handleReviewAddonUpdate: handleReviewAddonUpdate,
  updateMultipleWidgetProps: updateMultipleWidgetProps,
  scrollIntoView: scrollIntoViewWrapper,
  validateDataAndFields: validateDataAndFields,
  verify_otp_redirect: VerifyOtpAndRedirect,
  handleRouterBack: handleRouterBack,
  checkValueAndCall: checkValueAndCall,
  setRequestPayload: setRequestPayloadData,
  triggerEvent: analyticEvents,
  checkGlobalDataAndCall: checkGlobalDataAndCall,
  dispatchCallEvents: dispatchCallEvents,
  goToHomePage: GoToHomePage,
  checkMutipleValuesAndCall: checkMutipleValuesAndCall,
  redirect_to_payment_gateway: CheckoutComponent,
  resetPayloadData: resetPayloadData,
  resetInstrumentationData: resetInstrumentationData,
  triggerFirebaseEvent: triggerFirebaseEvent,
  goToMyAccount: GoToMyAccount,
  redirectToDefaultPaymentOrAutopay: RedirectToDefaultPaymentOrAutopay,
  redirectToUrl: RedirectToUrl,
  checkPayload: checkPayload,
  downloadAndOpenPdf: DownloadAndOpenPdf,
  redirectionToCheckoutOrNextNode: redirectionToCheckoutOrNextNode,
  persistPayloadToStorage: persistPayloadToStorage,
  updateDashcamAddress: updateDashcamAddress,
  showLoaderAndRedirectToHomepage: showLoaderAndRedirectToHomepage,
  openHomepage: openHomepage,
  removePayloadKey: removePayloadKeyAction,
  checkoutAndRedirectToPayment: checkoutAndRedirectToPayment,
  ConditionalGoBack: ConditionalGoBack,
  TraiConcentCall: traiConcentCall,
  updateProposal: updateProposal,
  appWebViewAuthFlow: appWebViewAuthFlow,
  fetch_ownership_transfer_and_redirect: fetchOwnershipTransferAndRedirect,
  dispatchAckoDriveCallback: dispatchAckoDriveCallback,
  openDeeplink: openDeeplink,
  markDashcamAsDelivered: markDashcamAsDelivered,
};

export default actions;
